import classNames from 'classnames'

import { DisplayPassage } from '../data/mappers'

export const getVignetteClasses = (passage: DisplayPassage) =>
  classNames(
    'flex w-36 min-w-36 max-w-36 h-[115px] items-center justify-center text-[78px] rounded-[18px] font-bold border-solid',
    {
      'opacity-50': passage.isDeparted,
    },
  )

export const getPassageTitleWrapperClasses = (hasStatusLabels: boolean) =>
  classNames('flex flex-grow flex-col text-[56px] font-bold', {
    truncate: hasStatusLabels,
  })
export const getPassageTitleClasses = (passage: DisplayPassage) =>
  classNames('text-ellipsis overflow-hidden ...', {
    'opacity-50': passage.isDeparted,
    'text-red-600 dark:text-red-darkText':
      passage.isNotServed || passage.isDeleted,
  })

export const getDisplayTimeClasses = (
  passage: DisplayPassage,
  hideTime: boolean,
) =>
  classNames('w-[168px] max-w-[168px] text-right text-[52px] font-bold', {
    'opacity-50': passage.isDeparted,
    'text-red-600 dark:text-red-darkText line-through':
      passage.isNotServed || passage.isDeleted,
    hidden: hideTime,
  })
